import { useUser } from '@clerk/clerk-react';
import { useViewAsClient } from './viewAsClient';

/* Triton staff are flagged via the user's public metadata:
   set `{ "role": "triton_admin" }` on the user in the Clerk Dashboard (or via
   the backend API). Admins can see the cross-client admin dashboard.

   Phase 3+: the Worker re-checks this server-side from the session claims before
   returning any cross-tenant data — never trust the client alone for authz. */
export function useIsAdmin(): boolean {
  const real = useIsRealAdmin();
  const [viewingAsClient] = useViewAsClient();
  // "View as client" hides every admin surface for a demo or support session.
  // Presentation only: the Worker still treats the caller as an admin.
  return real && !viewingAsClient;
}

/** The Clerk flag itself, unaffected by "View as client" — for the toggle and its banner. */
export function useIsRealAdmin(): boolean {
  const { user } = useUser();
  return user?.publicMetadata?.role === 'triton_admin';
}
